import { useDispatch } from "react-redux";

const useClearDefaultAccountant = () => {
  const dispatchAction = useDispatch();
  const clearDefaultAccountant = () => {
    localStorage.removeItem("studioSelected");
    localStorage.removeItem("selectedAccountantID");
    localStorage.removeItem("actualAccountantName");
    dispatchAction({
      type: "changeAccountant",
      accountantUuidSelected: "",
      accountantIdSelected: "",
      accountantSelected: ""
    });
  };

  return { clearDefaultAccountant };
};

export default useClearDefaultAccountant;
